export default [
  {
    code: "HK",
    name: "Hong Kong",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+852",
  },
  {
    code: "IN",
    name: "India",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+91",
  },
  {
    code: "LK",
    name: "Sri Lanka",
    region: "ASIA",
    dial_code: "+94",
  },
  {
    code: "ID",
    name: "Indonesia",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+62",
  },
  {
    code: "MY",
    name: "Malaysia",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+60",
  },
  {
    code: "PH",
    name: "Philippines",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+63",
  },
  {
    code: "SG",
    name: "Singapore",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+65",
  },
  {
    code: "TH",
    name: "Thailand",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+66",
  },
  {
    code: "VN",
    name: "Vietnam",
    region: "ASIA",
    duplicate_country: true,
    dial_code: "+84",
  },
  {
    code: "AT",
    name: "Austria",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+43",
  },
  {
    code: "BE",
    name: "Belgium",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+32",
  },
  {
    code: "DK",
    name: "Denmark",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+45",
  },
  {
    code: "FI",
    name: "Finland",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+358",
  },
  {
    code: "FR",
    name: "France",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+33",
  },
  {
    code: "DE",
    name: "Germany",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+49",
  },
  {
    code: "GR",
    name: "Greece",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+30",
  },
  {
    code: "SI",
    name: "Slovenia",
    region: "EUROPE",
    dial_code: "+386",
  },
  {
    code: "SK",
    name: "Slovakia",
    region: "EUROPE",
    dial_code: "+421",
  },
  {
    code: "RS",
    name: "Serbia",
    region: "EUROPE",
    dial_code: "+381",
  },
  {
    code: "AM",
    name: "Armenia",
    region: "EUROPE",
    dial_code: "+374",
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    region: "Other",
    dial_code: "+994",
  },
  {
    code: "HU",
    name: "Hungary",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+36",
  },
  {
    code: "IE",
    name: "Ireland",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+353",
  },
  {
    code: "IT",
    name: "Italy",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+39",
  },
  {
    code: "LU",
    name: "Luxembourg",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+352",
  },
  {
    code: "NL",
    name: "Netherlands",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+31",
  },
  {
    code: "NO",
    name: "Norway",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+47",
  },
  {
    code: "PL",
    name: "Poland",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+48",
  },
  {
    code: "PT",
    name: "Portugal",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+351",
  },
  {
    code: "RO",
    name: "Romania",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+40",
  },
  {
    code: "ES",
    name: "Spain",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+34",
  },
  {
    code: "SE",
    name: "Sweden",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+46",
  },
  {
    code: "CH",
    name: "Switzerland",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+41",
  },
  {
    code: "TR",
    name: "Turkey",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+90",
  },
  {
    code: "UK",
    name: "United Kingdom",
    region: "EUROPE",
    duplicate_country: true,
    dial_code: "+44",
  },
  {
    code: "AF",
    name: "Afghanistan",
    region: "Other",
    dial_code: "+93",
  },
  {
    code: "AL",
    name: "Albania",
    region: "Other",
    dial_code: "+355",
  },
  {
    code: "DZ",
    name: "Algeria",
    region: "Other",
    dial_code: "+213",
  },
  {
    code: "AD",
    name: "Andorra",
    region: "Other",
    dial_code: "+376",
  },
  {
    code: "AO",
    name: "Angola",
    region: "Other",
    dial_code: "+244",
  },
  {
    code: "BS",
    name: "Bahamas",
    region: "Other",
    dial_code: "+1242",
  },
  {
    code: "BD",
    name: "Bangladesh",
    region: "Other",
    dial_code: "+880",
  },
  {
    code: "BB",
    name: "Barbados",
    region: "Other",
    dial_code: "+1246",
  },
  {
    code: "BY",
    name: "Belarus",
    region: "Other",
    dial_code: "+375",
  },
  {
    code: "BZ",
    name: "Belize",
    region: "Other",
    dial_code: "+501",
  },
  {
    code: "BJ",
    name: "Benin",
    region: "Other",
    dial_code: "+229",
  },
  {
    code: "BT",
    name: "Bhutan",
    region: "Other",
    dial_code: "+975",
  },
  {
    code: "BO",
    name: "Bolivia",
    region: "Other",
    dial_code: "+591",
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    region: "Other",
    dial_code: "+387",
  },
  {
    code: "BW",
    name: "Botswana",
    region: "Other",
    dial_code: "+267",
  },
  {
    code: "BN",
    name: "Brunei Darussalam",
    region: "Other",
    dial_code: "+673",
  },
  {
    code: "BG",
    name: "Bulgaria",
    region: "Other",
    dial_code: "+359",
  },
  {
    code: "BF",
    name: "Burkina Faso",
    region: "Other",
    dial_code: "+226",
  },
  {
    code: "BI",
    name: "Burundi",
    region: "Other",
    dial_code: "+257",
  },
  {
    code: "KH",
    name: "Cambodia",
    region: "Other",
    dial_code: "+855",
  },
  {
    code: "CM",
    name: "Cameroon",
    region: "Other",
    dial_code: "+237",
  },
  {
    code: "CV",
    name: "Cape Verde",
    region: "Other",
    dial_code: "+238",
  },
  {
    code: "CF",
    name: "Central African Republic",
    region: "Other",
    dial_code: "+236",
  },
  {
    code: "TD",
    name: "Chad",
    region: "Other",
    dial_code: "+235",
  },
  {
    code: "CN",
    name: "China",
    region: "Other",
    dial_code: "+86",
  },
  {
    code: "CG",
    name: "Congo",
    region: "Other",
    dial_code: "+242",
  },
  {
    code: "CD",
    name: "Democratic Republic of Congo",
    region: "Other",
    dial_code: "+243",
  },
  {
    code: "CR",
    name: "Costa Rica",
    region: "Other",
    dial_code: "+506",
  },
  {
    code: "HR",
    name: "Croatia",
    region: "Other",
    dial_code: "+385",
  },
  {
    code: "CU",
    name: "Cuba",
    region: "Other",
    dial_code: "+53",
  },
  {
    code: "CY",
    name: "Cyprus",
    region: "Other",
    dial_code: "+357",
  },
  {
    code: "CZ",
    name: "Czech Republic",
    region: "Other",
    dial_code: "+420",
  },
  {
    code: "DJ",
    name: "Djibouti",
    region: "Other",
    dial_code: "+253",
  },
  {
    code: "DM",
    name: "Dominica",
    region: "Other",
    dial_code: "+1767",
  },
  {
    code: "DO",
    name: "Dominican Republic",
    region: "Other",
    dial_code: "+1849",
  },
  {
    code: "ER",
    name: "Eritrea",
    region: "Other",
    dial_code: "+291",
  },
  {
    code: "EE",
    name: "Estonia",
    region: "Other",
    dial_code: "+372",
  },
  {
    code: "ET",
    name: "Ethiopia",
    region: "Other",
    dial_code: "+251",
  },
  {
    code: "FJ",
    name: "Fiji",
    region: "Other",
    dial_code: "+679",
  },
  {
    code: "GA",
    name: "Gabon",
    region: "Other",
    dial_code: "+241",
  },
  {
    code: "GM",
    name: "Gambia",
    region: "Other",
    dial_code: "+220",
  },
  {
    code: "GE",
    name: "Georgia",
    region: "Other",
    dial_code: "+995",
  },
  {
    code: "GH",
    name: "Ghana",
    region: "Other",
    dial_code: "+233",
  },
  {
    code: "GI",
    name: "Gibraltar",
    region: "Other",
    dial_code: "+350",
  },
  {
    code: "GL",
    name: "Greenland",
    region: "Other",
    dial_code: "+299",
  },
  {
    code: "GD",
    name: "Grenada",
    region: "Other",
    dial_code: "+1473",
  },
  {
    code: "GT",
    name: "Guatemala",
    region: "Other",
    dial_code: "+502",
  },
  {
    code: "GN",
    name: "Guinea",
    region: "Other",
    dial_code: "+224",
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
    region: "Other",
    dial_code: "+245",
  },
  {
    code: "GY",
    name: "Guyana",
    region: "Other",
    dial_code: "+595",
  },
  {
    code: "HT",
    name: "Haiti",
    region: "Other",
    dial_code: "+509",
  },
  {
    code: "HN",
    name: "Honduras",
    region: "Other",
    dial_code: "+504",
  },
  {
    code: "IS",
    name: "Iceland",
    region: "Other",
    dial_code: "+354",
  },
  {
    code: "IR",
    name: "Iran",
    region: "Other",
    dial_code: "+98",
  },
  {
    code: "IQ",
    name: "Iraq",
    region: "Other",
    dial_code: "+964",
  },
  {
    code: "IL",
    name: "Israel",
    region: "Other",
    dial_code: "+972",
  },
  {
    code: "JM",
    name: "Jamaica",
    region: "Other",
    dial_code: "+1876",
  },
  {
    code: "JP",
    name: "Japan",
    region: "Other",
    dial_code: "+81",
  },
  {
    code: "JO",
    name: "Jordan",
    region: "Other",
    dial_code: "+962",
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    region: "Other",
    dial_code: "+77",
  },
  {
    code: "KE",
    name: "Kenya",
    region: "Other",
    dial_code: "+254",
  },
  {
    code: "KI",
    name: "Kiribati",
    region: "Other",
    dial_code: "+686",
  },
  {
    code: "KR",
    name: "South Korea",
    region: "Other",
    dial_code: "+82",
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
    region: "Other",
    dial_code: "+996",
  },
  {
    code: "LA",
    name: "Laos",
    region: "Other",
    dial_code: "+856",
  },
  {
    code: "LV",
    name: "Latvia",
    region: "Other",
    dial_code: "+371",
  },
  {
    code: "LB",
    name: "Lebanon",
    region: "Other",
    dial_code: "+961",
  },
  {
    code: "LS",
    name: "Lesotho",
    region: "Other",
    dial_code: "+266",
  },
  {
    code: "LR",
    name: "Liberia",
    region: "Other",
    dial_code: "+231",
  },
  {
    code: "LY",
    name: "Libya",
    region: "Other",
    dial_code: "+218",
  },
  {
    code: "LI",
    name: "Liechtenstein",
    region: "Other",
    dial_code: "+423",
  },
  {
    code: "LT",
    name: "Lithuania",
    region: "Other",
    dial_code: "+370",
  },
  {
    code: "MO",
    name: "Macao",
    region: "Other",
    dial_code: "+853",
  },
  {
    code: "MK",
    name: "North Macedonia",
    region: "Other",
    dial_code: "+389",
  },
  {
    code: "MG",
    name: "Madagascar",
    region: "Other",
    dial_code: "+261",
  },
  {
    code: "MW",
    name: "Malawi",
    region: "Other",
    dial_code: "+265",
  },
  {
    code: "MV",
    name: "Maldives",
    region: "Other",
    dial_code: "+960",
  },
  {
    code: "ML",
    name: "Mali",
    region: "Other",
    dial_code: "+223",
  },
  {
    code: "MT",
    name: "Malta",
    region: "Other",
    dial_code: "+356",
  },
  {
    code: "MH",
    name: "Marshall Islands",
    region: "Other",
    dial_code: "+692",
  },
  {
    code: "MQ",
    name: "Martinique",
    region: "Other",
    dial_code: "+596",
  },
  {
    code: "MR",
    name: "Mauritania",
    region: "Other",
    dial_code: "+222",
  },
  {
    code: "MU",
    name: "Mauritius",
    region: "Other",
    dial_code: "+230",
  },
  {
    code: "FM",
    name: "Federated States of Micronesia",
    region: "Other",
    dial_code: "+691",
  },
  {
    code: "MD",
    name: "Moldova",
    region: "Other",
    dial_code: "+373",
  },
  {
    code: "MC",
    name: "Monaco",
    region: "Other",
    dial_code: "+377",
  },
  {
    code: "MN",
    name: "Mongolia",
    region: "Other",
    dial_code: "+976",
  },
  {
    code: "ME",
    name: "Montenegro",
    region: "Other",
    dial_code: "+382",
  },
  {
    code: "MA",
    name: "Morocco",
    region: "Other",
    dial_code: "+212",
  },
  {
    code: "MM",
    name: "Myanmar",
    region: "Other",
    dial_code: "+95",
  },
  {
    code: "NP",
    name: "Nepal",
    region: "Other",
    dial_code: "+977",
  },
  {
    code: "NE",
    name: "Niger",
    region: "Other",
    dial_code: "+227",
  },
  {
    code: "PK",
    name: "Pakistan",
    region: "Other",
    dial_code: "+92",
  },
  {
    code: "PW",
    name: "Palau",
    region: "Other",
    dial_code: "+680",
  },
  {
    code: "PA",
    name: "Panama",
    region: "Other",
    dial_code: "+507",
  },
  {
    code: "PG",
    name: "Papua New Guinea",
    region: "Other",
    dial_code: "+675",
  },
  {
    code: "PY",
    name: "Paraguay",
    region: "Other",
    dial_code: "+595",
  },
  {
    code: "SL",
    name: "Sierra Leone",
    region: "Other",
    dial_code: "+232",
  },
  {
    code: "SD",
    name: "Sudan",
    region: "Other",
    dial_code: "+249",
  },
  {
    code: "SR",
    name: "Suriname",
    region: "Other",
    dial_code: "+597",
  },
  {
    code: "SZ",
    name: "Eswatini",
    region: "Other",
    dial_code: "+268",
  },
  {
    code: "SY",
    name: "Syria",
    region: "Other",
    dial_code: "+963",
  },
  {
    code: "TW",
    name: "Taiwan",
    region: "Other",
    dial_code: "+886",
  },
  {
    code: "TJ",
    name: "Tajikistan",
    region: "Other",
    dial_code: "+992",
  },
  {
    code: "UG",
    name: "Uganda",
    region: "Other",
    dial_code: "+256",
  },
  {
    code: "UA",
    name: "Ukraine",
    region: "Other",
    dial_code: "+380",
  },
  {
    code: "UY",
    name: "Uruguay",
    region: "Other",
    dial_code: "+598",
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    region: "Other",
    dial_code: "+998",
  },
  {
    code: "VU",
    name: "Vanuatu",
    region: "Other",
    dial_code: "+678",
  },
  {
    code: "YE",
    name: "Yemen",
    region: "Other",
    dial_code: "+967",
  },
  {
    code: "ZM",
    name: "Zambia",
    region: "Other",
    dial_code: "+260",
  },
  {
    code: "TZ",
    name: "Tanzania",
    region: "Other",
    dial_code: "+255",
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    region: "Other",
    dial_code: "+263",
  },
  {
    code: "NA",
    name: "Namibia",
    region: "Other",
    dial_code: "+264",
  },
  {
    code: "MZ",
    name: "Mozambique",
    region: "Other",
    dial_code: "+258",
  },
  {
    code: "RW",
    name: "Rwanda",
    region: "Other",
    dial_code: "+250",
  },
  {
    code: "SO",
    name: "Somalia",
    region: "Other",
    dial_code: "+252",
  },
  {
    code: "VE",
    name: "Venezuela",
    region: "Other",
    dial_code: "+58",
  },
  {
    code: "NG",
    name: "Nigeria",
    region: "Africa",
    duplicate_country: true,
    dial_code: "+234",
  },
  {
    code: "SN",
    name: "Senegal",
    region: "Africa",
    dial_code: "+221",
  },
  {
    code: "ZA",
    name: "South Africa",
    region: "Africa",
    duplicate_country: true,
    dial_code: "+27",
  },
  {
    code: "US",
    name: "USA",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+1",
  },
  {
    code: "BR",
    name: "Brazil",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+55",
  },
  {
    code: "AR",
    name: "Argentina",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+54",
  },
  {
    code: "CA",
    name: "Canada",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+1",
  },
  {
    code: "CL",
    name: "Chile",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+56",
  },
  {
    code: "CO",
    name: "Colombia",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+57",
  },
  {
    code: "EC",
    name: "Ecuador",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+593",
  },
  {
    code: "MX",
    name: "Mexico",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+52",
  },
  {
    code: "PE",
    name: "Peru",
    region: "Americas",
    duplicate_country: true,
    dial_code: "+51",
  },
  {
    code: "AU",
    name: "Australia",
    region: "Australasia",
    duplicate_country: true,
    dial_code: "+61",
  },
  {
    code: "NZ",
    name: "New Zealand",
    region: "Australasia",
    duplicate_country: true,
    dial_code: "+64",
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+971",
  },
  {
    code: "EG",
    name: "Egypt",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+20",
  },
  {
    code: "BH",
    name: "Bahrain",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+973",
  },
  {
    code: "KW",
    name: "Kuwait",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+965",
  },
  {
    code: "OM",
    name: "Oman",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+968",
  },
  {
    code: "QA",
    name: "Qatar",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+974",
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    region: "Middle East",
    duplicate_country: true,
    dial_code: "+966",
  },
];
